// extracted by mini-css-extract-plugin
module.exports =  {"root":"HSxlo1AGFErI9Vr7CJXW","zoomButton":"_HY98cD_Lwz2oAxbkCJl","shortcut":"kftmMNq4GV2TA3qlfNRJ"};